var render = function render(){var _vm=this,_c=_vm._self._c;return _c('doughnut',{ref:"skills_chart",attrs:{"chartData":_vm.graphData,"options":_vm.options,"height":350,"width":350}})
}
var staticRenderFns = []

export { render, staticRenderFns }